<template>
  <UserLayout>
    <section class="mx-28">
      <div v-if="loadingStatus">
        <ContentLoader :size="4" :type="'session'"></ContentLoader>
      </div>
      <div v-else class="my-10">
        <h6
          class="md:text-2xl text-xl font-semibold mb-10 leading-normal text-gray-dark"
        >
          Available Classes
        </h6>
        <div
          v-if="data && data.length"
          class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-5"
        >
          <div v-for="d in data" :key="d.id" class="">
            <!-- <NewSessionCard :data="d" /> -->
            <Card :data="d"/>
          </div>
        </div>
        <span class="text-xs text-gray-700" v-else>No data found.</span>
      </div>
    </section>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import ContentLoader from "@/components/vue-spinner/ContentLoader";
//import NewSessionCard from "@/components/NewSessionCard";
import Card from "@/components/card/Card.vue";

export default {
  name: "AllSessions",
  components: {
    UserLayout,
    ContentLoader,
    //NewSessionCard,
    Card,
  },
  data() {
    return {
      data: null,
    };
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  created() {
    this.data = this.$route.params.data;
  },
};
</script>
